// hooks
import { useClientsMap, useMountpointsMap } from 'api'
import { ClientFilters, MountpointFilters, useMapContext } from './context/MapProvider'
import { useTheme } from '@material-ui/core/styles'
// compoents
import Card from 'common/Card'
import Tooltip from '@material-ui/core/Tooltip'
import IconButton from '@material-ui/core/IconButton'
import Divider from '@material-ui/core/Divider'
// icons
import { ReactComponent as MountpointIcon } from '../assets/icons/tooltip.svg'
import { MountpointsIcon, UsersIcon } from '../icons'
//
import { strings } from 'strings'

const MapStatusBar = () => {
  const palette = useTheme().palette

  const {
    mountpoints: filteredMountpoints,
    mountpointFilters,
    setMountpointFilters,
    clients: filteredClients,
    clientFilters,
    setClientFilters,
  } = useMapContext()

  const { rtkFixedClients, rtkFloatClients, dgnssClients, notFixedClients } = useClientsMap()

  const clientCounts = [
    { label: 'None', name: 'notFixed', count: notFixedClients.length, color: '#EA4335' },
    { label: 'DGNSS', name: 'dgnss', count: dgnssClients.length, color: 'gold' },
    { label: 'RTK Float', name: 'rtkFloat', count: rtkFloatClients.length, color: 'orange' },
    { label: 'RTK Fixed', name: 'rtkFixed', count: rtkFixedClients.length, color: '#01CB09' },
  ]

  const {
    connectedMountpoints,
    unstableMountpoints,
    disconnectedMountpoints,
    inactiveMountpoints,
    coordAlertMountpoints,
  } = useMountpointsMap()

  const mountpointCounts = [
    {
      label: strings.coordinateDifference,
      name: 'coordAlert',
      count: coordAlertMountpoints.length,
      color: '#f3960a',
      hideEmpty: true,
    },
    {
      label: strings.inactive,
      name: 'inactive',
      count: inactiveMountpoints.length,
      color: '#5F6368',
    },
    {
      label: strings.disconnected,
      name: 'disconnected',
      count: disconnectedMountpoints.length,
      color: '#C62626',
    },
    {
      label: strings.unstable,
      name: 'unstable',
      count: unstableMountpoints.length,
      color: '#BBB919',
    },
    {
      label: strings.active,
      name: 'connected',
      count: connectedMountpoints.length,
      color: '#499E22',
    },
  ]

  return (
    <Card
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        padding: '8px 4px',
      }}
    >
      <div style={{ display: 'flex', gap: 7.5, alignItems: 'center' }}>
        {clientCounts.map((clientCount) => (
          <Tooltip title={clientCount.label} key={clientCount.label}>
            <IconButton
              onClick={() => {
                if (clientCount.count)
                  setClientFilters({
                    ...clientFilters,
                    [clientCount.name]: !clientFilters[clientCount.name as ClientFilters],
                  })
              }}
              style={{ padding: 0 }}
            >
              <div
                style={{
                  width: 24,
                  height: 24,
                  background: !clientFilters[clientCount.name as ClientFilters]
                    ? palette.action.disabled
                    : clientCount.color,
                  borderRadius: '50%',
                }}
              />
              <p style={{ position: 'absolute', fontSize: '1rem', color: 'snow' }}>
                {clientCount.count}
              </p>
            </IconButton>
          </Tooltip>
        ))}
        <IconButton
          onClick={() => {
            if (filteredClients.length === 0)
              setClientFilters({ rtkFixed: true, rtkFloat: true, dgnss: true, notFixed: true })
            else
              setClientFilters({
                rtkFixed: !rtkFixedClients.length,
                rtkFloat: !rtkFloatClients.length,
                dgnss: !dgnssClients.length,
                notFixed: !notFixedClients.length,
              })
          }}
          style={{ padding: 0 }}
        >
          <UsersIcon />
        </IconButton>
      </div>

      <Divider orientation="vertical" flexItem />

      <div style={{ display: 'flex', gap: 7.5, alignItems: 'center' }}>

        {mountpointCounts.reduce<JSX.Element[]>((acc, mountpointCount) => {
          if (!mountpointCount.hideEmpty || mountpointCount.count !== 0)
            acc.push(
              <Tooltip title={mountpointCount.label} key={mountpointCount.label}>
                <IconButton
                  onClick={() => {
                    if (mountpointCount.count) {
                      setMountpointFilters({
                        ...mountpointFilters,
                        [mountpointCount.name]:
                          !mountpointFilters[mountpointCount.name as MountpointFilters],
                      })
                    }
                  }}
                  style={{ padding: 0 }}
                >
                  <MountpointIcon
                    fill={
                      // !mountpointCount.count ||
                      !mountpointFilters[mountpointCount.name as MountpointFilters]
                        ? palette.action.disabled
                        : mountpointCount.color
                    }
                    width={34}
                    height={34}
                  />
                  <p style={{ position: 'absolute', bottom: -6, fontSize: '1rem', color: 'snow' }}>
                    {mountpointCount.count}
                  </p>
                </IconButton>
              </Tooltip>,
            )

          return acc
        }, [])}
        <IconButton
          onClick={() => {
            if (filteredMountpoints.length === 0)
              setMountpointFilters({
                connected: true,
                unstable: true,
                disconnected: true,
                inactive: true,
                coordAlert: true,
              })
            else
              setMountpointFilters({
                connected: !connectedMountpoints.length,
                unstable: !unstableMountpoints.length,
                disconnected: !disconnectedMountpoints.length,
                inactive: !inactiveMountpoints.length,
                coordAlert: !coordAlertMountpoints.length,
              })
          }}
          style={{ padding: 0 }}
        >
          <MountpointsIcon />
        </IconButton>
      </div>
    </Card>
  )
}

export default MapStatusBar
